(function(){
  var inApp=false;
  function markApp(){
    if(inApp){return;}
    inApp=true;
    document.documentElement.classList.add('mh-in-app');
    try{sessionStorage.setItem('mh_app','1');}catch(e){}
  }
  function tc(){return (window.Tapcart&&window.Tapcart.isInitialized)?window.Tapcart:null;}
  try{
    if(/[?&](tapcart|app)=1(&|$)/.test(location.search)||sessionStorage.getItem('mh_app')==='1'){markApp();}
  }catch(e){}
  var tries=0;
  var poll=setInterval(function(){
    if(tc()){markApp();clearInterval(poll);}
    else if(++tries>60){clearInterval(poll);}
  },250);

  function toApp(items){
    var T=tc();
    if(!T||!items||!items.length){return false;}
    var lines=items.map(function(i){
      var li={variantId:String(i.id||i.variant_id||i.variantId),quantity:Number(i.quantity||1)};
      var sp=i.selling_plan||i.sellingPlanId||i.selling_plan_id;
      if(sp){li.sellingPlanId=String(sp);}
      return li;
    });
    try{
      T.actions.addToCart({lineItems:lines},{
        onSuccess:function(){try{T.actions.showToast({type:'success',message:'Added to your cart'});}catch(e){}},
        onError:function(){try{T.actions.showToast({type:'error',message:'Could not add to cart, please try again'});}catch(e){}}
      });
      return true;
    }catch(e){return false;}
  }

  /* Note: Octane's quiz.js already sends results "Add to cart" to the Tapcart cart itself when the
     Tapcart Web Bridge is initialized, so nothing extra is needed here. toApp() is kept as a manual helper. */
  window.__mhAppAddToCart=toApp;

  /* Keep the hidden storefront cart in the app web view empty: swallow Octane's /cart/add.js call when in app */
  var isCartAdd=function(u){return /\/cart\/add(\.js)?(\?|$)/.test(String(u||''));};
  var XO=XMLHttpRequest.prototype.open, XS=XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open=function(m,u){this.__mhUrl=u;return XO.apply(this,arguments);};
  XMLHttpRequest.prototype.send=function(body){
    if(inApp&&tc()&&isCartAdd(this.__mhUrl)){
      var xhr=this, items=[];
      try{var p=typeof body==='string'?JSON.parse(body):null;if(p&&p.items){items=p.items;}}catch(e){}
      var out=JSON.stringify({items:items.map(function(i){return {id:Number(i.id),variant_id:Number(i.id),quantity:Number(i.quantity||1)};})});
      ['readyState','status','statusText','responseText','response','responseURL'].forEach(function(k){
        var v={readyState:4,status:200,statusText:'OK',responseText:out,response:out,responseURL:location.origin+'/cart/add.js'}[k];
        try{Object.defineProperty(xhr,k,{configurable:true,get:function(){return v;}});}catch(e){}
      });
      setTimeout(function(){
        try{xhr.dispatchEvent(new Event('readystatechange'));}catch(e){}
        try{if(typeof xhr.onreadystatechange==='function'){xhr.onreadystatechange(new Event('readystatechange'));}}catch(e){}
        try{xhr.dispatchEvent(new Event('load'));}catch(e){}
        try{xhr.dispatchEvent(new Event('loadend'));}catch(e){}
      },50);
      return;
    }
    return XS.apply(this,arguments);
  };
  var OF=window.fetch;
  window.fetch=function(input,init){
    var u=typeof input==='string'?input:(input&&input.url)||'';
    if(inApp&&tc()&&isCartAdd(u)){
      var items=[];
      try{var b=init&&init.body;var p=typeof b==='string'?JSON.parse(b):null;if(p&&p.items){items=p.items;}}catch(e){}
      var out=JSON.stringify({items:items.map(function(i){return {id:Number(i.id),variant_id:Number(i.id),quantity:Number(i.quantity||1)};})});
      return Promise.resolve(new Response(out,{status:200,headers:{'Content-Type':'application/json'}}));
    }
    return OF.apply(this,arguments);
  };

  /* "View cart" / "Checkout" buttons inside the quiz open the app cart instead of the web cart */
  document.addEventListener('click',function(e){
    if(!inApp||!tc()){return;}
    var t=e.target&&e.target.closest?e.target.closest('a,button'):null;
    if(!t||!t.closest('.octane-ai-quiz')){return;}
    var txt=(t.textContent||'').trim();
    var href=t.getAttribute('href')||'';
    if(/^(view cart|go to cart|checkout|go to checkout)$/i.test(txt)||/\/cart(\?|$)|\/checkout/.test(href)){
      e.preventDefault();e.stopPropagation();
      try{tc().actions.openCart();}catch(x){}
    }
  },true);
})();
